import { agentControllerConversationRefSchema } from "./conversation-contract.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/controller-contract.ts
const LEGACY_RUNTIME_DISPATCH_POLICY = "mention_only";
const runtimeDispatchPolicySchema = z$1.enum([LEGACY_RUNTIME_DISPATCH_POLICY, "listen_all"]);
const runtimeTransportModeSchema = z$1.enum([
	"local-cli",
	"codex-app-server",
	"acp"
]);
const runtimeStreamingModeSchema = z$1.enum(["final", "stream"]);
const runtimeAgentControllerConversationIdMappingSpecSchema = z$1.strictObject({
	sourceField: z$1.string().min(1),
	mappingVersion: z$1.number().int().min(1)
});
const runtimeAgentExecutableLaunchContractSchema = z$1.strictObject({
	kind: z$1.literal("executable"),
	commandPath: z$1.string().min(1),
	argsPrefix: z$1.array(z$1.string().min(1)).optional()
});
const runtimeAgentNodeScriptLaunchContractSchema = z$1.strictObject({
	kind: z$1.literal("node_script"),
	nodePath: z$1.string().min(1),
	scriptPath: z$1.string().min(1),
	argsPrefix: z$1.array(z$1.string().min(1)).optional()
});
const runtimeAgentControllerLaunchContractSchema = z$1.discriminatedUnion("kind", [runtimeAgentExecutableLaunchContractSchema, runtimeAgentNodeScriptLaunchContractSchema]);
const runtimeAgentControllerLaunchCandidateSchema = z$1.strictObject({
	installId: z$1.string().min(1),
	label: z$1.string().min(1),
	detail: z$1.string().min(1),
	commandPath: z$1.string().min(1),
	launchContract: runtimeAgentControllerLaunchContractSchema
});
const runtimeAgentControllerSettingsSchema = z$1.strictObject({
	dispatch_policy: runtimeDispatchPolicySchema.default(LEGACY_RUNTIME_DISPATCH_POLICY),
	transport_mode: runtimeTransportModeSchema,
	streaming_mode: runtimeStreamingModeSchema.default("final"),
	timeout_ms: z$1.number().int().positive().nullable().default(null),
	retry: z$1.number().int().min(0).default(0),
	context_id_mapping_spec: runtimeAgentControllerConversationIdMappingSpecSchema
});
const agentContextResolutionSchema = z$1.strictObject({
	agentControllerConversationId: z$1.string().min(1).nullable(),
	agentControllerConversation: agentControllerConversationRefSchema.nullable().optional(),
	sourceField: z$1.string().min(1),
	mappingVersion: z$1.number().int().min(1)
});
//#endregion
export { LEGACY_RUNTIME_DISPATCH_POLICY, agentContextResolutionSchema, runtimeAgentControllerConversationIdMappingSpecSchema, runtimeAgentControllerLaunchCandidateSchema, runtimeAgentControllerLaunchContractSchema, runtimeAgentControllerSettingsSchema, runtimeAgentExecutableLaunchContractSchema, runtimeAgentNodeScriptLaunchContractSchema, runtimeDispatchPolicySchema, runtimeStreamingModeSchema, runtimeTransportModeSchema };

//# sourceMappingURL=controller-contract.js.map